import api from '@/store/api'

import { AIMessage } from './types'
import { WSResponse } from '@/services/ws/utils/types'

type AIAgentMessagesApiResponse = {
  thread_id: string
  messages: AIMessage[]
  message_count: number
}

export const fetchThread = async (threadId: string) => {
  try {
    const result = await api.get<AIAgentMessagesApiResponse>(
      `ai_conversations/${threadId}`,
    )
    return result.data.messages
  } catch (e) {
    throw Error(e as string)
  }
}

export const destroyTread = async (threadId: string) => {
  try {
    await api.delete(
      `ai_conversations/${threadId}`,
    )
  } catch (e) {
    throw Error(e as string)
  }
}

export const prepareMessages = (content: string) => {
  const messages: AIMessage[] = []
  const message: AIMessage = {
    role: 'human',
    content,
  }
  messages.push(message)
  return { messages, message }
}

export const handleResponse = (
  requestId: string,
  currentThreadId: string,
  message: WSResponse<string>,
  setErrorMessage: (error: string) => void,
  setCurrentThreadId: (threadId: string) => void,
  pushMessage: (message: AIMessage) => void,
  setConversationLastUpdated?: (threadId: string) => void,
) => {
  try {
    if (message.errors) {
      const errors = message.errors.join(', ')
      setErrorMessage(errors)
      return
    }
    if (!message.data || requestId !== currentThreadId) return
    if (message.thread_id) {
      setCurrentThreadId(message.thread_id)
      setConversationLastUpdated?.(message.thread_id)
    }
    pushMessage({
      role: 'ai',
      content: message.data,
    })
  } catch (e) {
    throw Error(e as string)
  }
}
